import { render, staticRenderFns } from "./GestionFicheros.vue?vue&type=template&id=05391220&"
import script from "./GestionFicheros.vue?vue&type=script&lang=js&"
export * from "./GestionFicheros.vue?vue&type=script&lang=js&"
import style0 from "./GestionFicheros.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports